import { TextStyle } from "react-native";
import { HelperText } from "react-native-paper";

type Props = {
  info?: string | React.ReactNode;
  error?: string | React.ReactNode;
  numberOfLines?: number;
  style?: TextStyle;
};

export default function TextInputHelperText({
  error = "",
  info = "* Campo requerido",
  numberOfLines,
  style,
}: Props) {
  return (
    <HelperText
      type={error ? "error" : "info"}
      style={style}
      numberOfLines={numberOfLines}
    >
      {error || info}
    </HelperText>
  );
}
